var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\xC9l\\xE9ments",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icones/Doc/Plan/Fill/Noir",
    className: "st0-fill",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16,20 L6,20 L6,6 L8,6 C8,6.553 8.447,7 9,7 L13,7 C13.267,7 13.521,6.894 13.709,6.705 C13.896,6.518 13.999,6.265 13.999,6 L16,6 L16,20 Z M11,3 C11.276,3 11.5,3.224 11.5,3.5 C11.5,3.776 11.276,4 11,4 C10.724,4 10.5,3.776 10.5,3.5 C10.5,3.224 10.724,3 11,3 L11,3 Z M17,4 L13.614,4 L12.896,2.555 C12.727,2.215 12.38,2 12,2 L10,2 C9.621,2 9.275,2.214 9.105,2.553 L8.382,4 L5,4 C4.447,4 4,4.447 4,5 L4,21 C4,21.553 4.447,22 5,22 L17,22 C17.553,22 18,21.553 18,21 L18,5 C18,4.447 17.553,4 17,4 L17,4 Z",
    id: "Fill-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,22 C19.447,22 19,21.553 19,21 L19,13 C19,12.447 20,10 20,10 C20,10 21,12.447 21,13 L21,21 C21,21.553 20.553,22 20,22",
    id: "Fill-3"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlan);
export default __webpack_public_path__ + "static/media/plan.778617f7a0c53f40bd949e28b548b7f6.svg";
export { ForwardRef as ReactComponent };